import { downloadXLSX } from 'common/Utils/downloadUtils'
import Alert from 'components/Common/Alert'
import Breadcrumbs from 'components/Common/Breadcrumb'
import Loader from 'components/Common/Loader'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { MetaTags } from 'react-meta-tags'
import { connect } from 'react-redux'
import { getManagers, getQualityProblems, getQualitySolutions } from 'store/actions'
import CreateIncidenceModal from './CreateIncidenceModal'
import FilterModal from './FilterModal'
import ImagesModal from './ImagesModal'
import OrderIncidence from './OrderIncidence'

export const Incidences = ({ t, incidences, isLoading, isLoadingIncidences, error, getQualityProblems, getQualitySolutions, problems, solutions, managers, getManagers }) => {

	const [openedOrderIds, setOpenedOrderIds] = useState([])
	const [isCreateIncidenceModalOpen, setIsCreateIncidenceModalOpen] = useState(false)

	useEffect(() => {
		getQualityProblems()
		getQualitySolutions()
		getManagers()
	}, [])


	const handleToggleOrder = (orderId) => {
		if (openedOrderIds.includes(orderId)) {
			setOpenedOrderIds(openedOrderIds.filter((id) => id !== orderId))
		} else {
			setOpenedOrderIds([...openedOrderIds, orderId])
		}

	}
	const getIncidencesToRender = () => {
		return incidences.map((incidence, index) => (
			<div key={`${incidence.order.id}_${index}`}>
				<OrderIncidence openedOrderIds={openedOrderIds} incidence={incidence} handleToggleOrder={handleToggleOrder} rowIndex={index} />
			</div>))
	}

	const exportExcel = () => {
		downloadXLSX({
			rows: [
				{
					orderId: t('order_id', { ns: 'naming' }),
					partId: t('part_id', { ns: 'naming' }),
					client: t('client', { ns: 'naming' }),
					notifiedBy: t('notified_by', { ns: 'naming' }),
					shipmentDate: t('shipment_date', { ns: 'naming' }),
					manager: t('manager', { ns: 'naming' }),
					observation: t('observation', { ns: 'naming' }),
				},
				...incidences.flatMap(incidence => {
					const manager = managers.find(manager => manager.id === incidence.order.organization.managerId)
					const clientName = `${incidence.order.shippingAddress.firstName || ''} ${incidence.order.shippingAddress.lastName || ''}`
					const managerName = `${manager?.personalInformation?.firstName || ''} ${manager?.personalInformation?.lastName || ''}`
					return incidence.items.flatMap(item => {
						return item.incidences.map(inc => {
							return {
								orderId: incidence.order.id,
								partId: item.orderItem.partId,
								client: clientName.trim(),
								notifiedBy: inc.notifiedBy == 'quality' ? t('quality', { ns: 'naming' }) : inc.notifiedBy == 'client' ? t('client', { ns: 'naming' }) : inc.notifiedBy,
								shipmentDate: incidence.order.deliveryDate ? new Date(incidence.order.deliveryDate).toLocaleDateString() : '',
								manager: managerName.trim(),
								observation: inc.observation || '',
							}
						})
					})
				}),
			],
			fileName: 'incidences.xlsx',
		})
	}

	const items = useMemo(() => getIncidencesToRender(), [openedOrderIds, incidences])
	return (
		<div className='page-content marginFooter'>
			<MetaTags>
				<title>Proto&Go! | {t('incidences', { ns: 'naming' })}</title>
			</MetaTags>
			<Breadcrumbs
				title={t('quality', { ns: 'naming' })}
				breadcrumbItems={[
					{
						item: t('incidences', { ns: 'naming' }),
						link: '/incidences',
					},
				]}
			/>
			<div className='d-flex justify-content-center flex-column w-100 mb-1'>

				<div className='d-flex flex align-items-center bg-white w-100 ms-2'>
					<FilterModal />
					<button className='btn btn-primary' onClick={() => setIsCreateIncidenceModalOpen(true)}>{t('add', { ns: 'naming' })}</button>
					<div className='justify-content-end d-flex flex-row w-100 me-4' >
						<button
							className="btn btn-success" style={{ width: 'auto' }}
							onClick={() => exportExcel()}
							disabled={(isLoading || isLoadingIncidences && !isCreateIncidenceModalOpen)}
						>
							{t('export_incidences', { ns: 'naming' })}
						</button>
					</div>
				</div>
				{
					(isLoading || isLoadingIncidences && !isCreateIncidenceModalOpen) ? <Loader className='mx-auto fs-1' /> : (error && !isCreateIncidenceModalOpen) ? <Alert type={'danger'} message={error} fitContent centered /> :
						<div className='d-flex w-100 flex-column'>
							{incidences.length > 0 && problems.length > 0 && solutions.length > 0 && managers.length > 0 ?
								<>
									<div className='w-100 mx-2 sticky px-4 rounded d-flex flex-row align-items-center bg-white pb-3 mb-2 fw-bold'>
										<span className='col-1'><i className='bx bx-code ms-1 fs-3 mt-1' ></i></span>
										<span className='col-1'>{t('order_id', { ns: 'naming' })}</span>
										<span className='col'>{t('order_date', { ns: 'naming' })}</span>
										<span className='col'>{t('solved', { ns: 'naming' })}</span>
										<span className='col'>{t('client', { ns: 'naming' })}</span>
										<span className='col'>{t('manager', { ns: 'naming' })}</span>
										<span className='col'>{t('shipmentDate', { ns: 'naming' })}</span>
										<span className='col-1'>{t('incidences', { ns: 'naming' })}</span>
									</div>
									{items}
								</> : 'No incidences'}
						</div>
				}
			</div>

			<ImagesModal />
			<CreateIncidenceModal
				isOpen={isCreateIncidenceModalOpen}
				closeModal={() => setIsCreateIncidenceModalOpen(false)}
				productions={[]}
				incidences={incidences}
			/>
		</div>
	)
}

Incidences.propTypes = {
	t: PropTypes.func,
	getQualityProblems: PropTypes.func,
	getQualitySolutions: PropTypes.func,
	incidences: PropTypes.array,
	isLoading: PropTypes.bool,
	isLoadingIncidences: PropTypes.bool,
	error: PropTypes.string,
	problems: PropTypes.array,
	solutions: PropTypes.array,
	managers: PropTypes.array,
	getManagers: PropTypes.func,
	managers: PropTypes.array,
}

const mapStateToProps = (state) => ({
	incidences: state.Orders.incidences,
	isLoading: state.Orders.isLoading,
	isLoadingIncidences: state.Orders.isLoadingIncidences,
	error: state.Orders.error,
	problems: state.Orders.qualityProblems,
	solutions: state.Orders.qualitySolutions,
	managers: state.Users.managers,

})

const mapDispatchToProps = {
	getQualityProblems,
	getQualitySolutions,
	getManagers,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Incidences))
